export const CLIENT_JOURNALS_URL = '/journal';

/**
 * Cards per portion of the issues grid — what "Загрузить еще" adds. The grid
 * pages on the server: the section holds 839 issues and the client never has
 * them all
 */
export const JOURNAL_ISSUES_PAGE_SIZE = 8;

export const CLIENT_API_JOURNALS_URL = '/main/journals/';
export const CLIENT_API_JOURNALS_KEY = 'client_journals_list';

export const CLIENT_API_JOURNAL_DETAIL_URL = '/main/journals/';
export const CLIENT_API_JOURNAL_DETAIL_KEY = 'client_journal_detail';

export const CLIENT_API_JOURNAL_ORDERS_URL = '/orders/create/';

/** The reference of active editions, a flat array without pagination */
export const CLIENT_API_JOURNAL_EDITIONS_URL = '/main/journal-editions/';
export const CLIENT_API_JOURNAL_EDITIONS_KEY = 'client_journal_editions';

/** Year chips of the "Архив журнала CRE" block: ?edition=<id> */
export const CLIENT_API_JOURNAL_YEARS_URL = '/main/journals/years/';
export const CLIENT_API_JOURNAL_YEARS_KEY = 'client_journal_years';

export const CLIENT_API_JOURNAL_SETTINGS_URL = '/main/journal-settings/';
export const CLIENT_API_JOURNAL_SETTINGS_KEY = 'client_journal_settings';

// "Рекомендации" and "Реклама" go through the publishers endpoint:
// see CLIENT_JOURNAL_RECOMMENDED_URL in ~/shared/api/client/publisher

// Current cre.ru URLs: /journal/cre/i884 is an issue, /journal/cre/y2025 an archive year
export const JOURNAL_ISSUE_URL_PREFIX = 'i';
export const JOURNAL_YEAR_URL_PREFIX = 'y';
